import { render, staticRenderFns } from "./DfHiddenField.vue?vue&type=template&id=4f823f6a&"
import script from "./DfHiddenField.vue?vue&type=script&lang=js&"
export * from "./DfHiddenField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports